var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4428 15.3704C17.2528 15.3704 17.0628 15.3004 16.9128 15.1504C16.6228 14.8604 16.6228 14.3804 16.9128 14.0904L18.9428 12.0604L16.9128 10.0304C16.6228 9.74043 16.6228 9.26043 16.9128 8.97043C17.2028 8.68043 17.6828 8.68043 17.9728 8.97043L20.5328 11.5304C20.8228 11.8204 20.8228 12.3004 20.5328 12.5904L17.9728 15.1504C17.8228 15.3004 17.6328 15.3704 17.4428 15.3704Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9278 12.8096H9.75781C9.34781 12.8096 9.00781 12.4696 9.00781 12.0596C9.00781 11.6496 9.34781 11.3096 9.75781 11.3096H19.9278C20.3378 11.3096 20.6778 11.6496 20.6778 12.0596C20.6778 12.4696 20.3378 12.8096 19.9278 12.8096Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7578 20.75C6.60781 20.75 3.00781 17.15 3.00781 12C3.00781 6.85 6.60781 3.25 11.7578 3.25C12.1678 3.25 12.5078 3.59 12.5078 4C12.5078 4.41 12.1678 4.75 11.7578 4.75C7.48781 4.75 4.50781 7.73 4.50781 12C4.50781 16.27 7.48781 19.25 11.7578 19.25C12.1678 19.25 12.5078 19.59 12.5078 20C12.5078 20.41 12.1678 20.75 11.7578 20.75Z",
    fill: "#B0BECF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c5a7d73d80afca1ea79ad5982d4ec8af.svg";
export { ForwardRef as ReactComponent };